import * as React from 'react';

const SvgMoon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    style={{
      enableBackground: 'new 0 0 512 512',
    }}
    xmlSpace="preserve"
    {...props}
  >
    <circle
      style={{
        fill: '#263a7a',
      }}
      cx={256}
      cy={256}
      r={256}
    />
    <path
      style={{
        fill: '#121149',
      }}
      d="M274.253 511.345c101.633-7.161 186.878-73.642 221.344-165.036L238.411 89.122l-101.36 62.869-32.754 168.943 28.389 48.843 141.567 141.568z"
    />
    <path
      style={{
        fill: '#ffc61b',
      }}
      d="M305.778 341.333c-74.619 0-135.111-60.492-135.111-135.111 0-50.079 27.267-93.762 67.744-117.1C154.009 97.914 88.207 169.27 88.207 256c0 92.67 75.124 167.793 167.793 167.793 86.73 0 158.086-65.803 166.878-150.204-23.339 40.477-67.021 67.744-117.1 67.744z"
    />
    <path
      style={{
        fill: '#eaa22f',
      }}
      d="M305.778 341.333c-37.017 0-70.546-14.898-94.949-39.012l-72.894 72.894c30.318 30.027 72.023 48.578 118.065 48.578 86.73 0 158.086-65.803 166.878-150.204-23.339 40.477-67.021 67.744-117.1 67.744z"
    />
  </svg>
);

export default SvgMoon;
